import { useMemo } from 'react'
import { useLeaseContractsList } from './useLeaseContracts'

const BANK_ACCOUNT_CONFIRMATION_DISMISSED_KEY = 'bankAccountConfirmationDismissed'

export const useBankAccountConfirmationCheck = () => {
  const { leaseContractsList, isLoading } = useLeaseContractsList()

  const shouldShowBankAccountConfirmation = useMemo(() => {
    if (isLoading || !leaseContractsList) return false

    // Check if user has already dismissed the dialog
    const isDismissed = localStorage.getItem(BANK_ACCOUNT_CONFIRMATION_DISMISSED_KEY) === 'true'
    if (isDismissed) return false

    // Check if there's any contract with leaseStatus = 0 and effectiveLeaseEnd != null
    return leaseContractsList.some(contract => 
      contract.leaseStatus === 0 && 
      contract.effectiveLeaseEnd !== null && 
      contract.effectiveLeaseEnd !== undefined
    )
  }, [leaseContractsList, isLoading])

  const dismissBankAccountConfirmation = () => {
    localStorage.setItem(BANK_ACCOUNT_CONFIRMATION_DISMISSED_KEY, 'true')
  }

  return {
    shouldShowBankAccountConfirmation,
    dismissBankAccountConfirmation,
    isLoading
  }
}
